import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQLMutationObject,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { transformCartBenefits } from '../../../mapper';
import { IProductsUpdateData } from '../model';

import { IPutProducts, IUpdateProductResponse } from './model';
import { UPDATE_PRODUCT_MUTATION } from './updateProductMutation';

const mappingFunction = (result: IUpdateProductResponse): IGeneralRequestResponse<IProductsUpdateData> => {
  const {
    updateProduct: { data },
  } = result;

  return {
    ...result.updateProduct,
    data: {
      ...data,
      benefits: transformCartBenefits(data.benefits),
    },
  };
};

export const usePutProductAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IProductsUpdateData>,
  IPutProducts
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IProductsUpdateData>,
    IGraphQLMutationObject<IPutProducts>,
    IUpdateProductResponse
  >({
    method: httpMethods.PUT,
    path: ApiSectionNamespace.ECartPageApiKeys.CART_PAGE_PRODUCTS_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (data?: IPutProducts) => {
      const payload = { query: UPDATE_PRODUCT_MUTATION, ...(data && { variables: { product: data } }) };
      return awaitableRequest({ data: payload });
    },
    [awaitableRequest],
  );

  return { request };
};
